<template>
    <div class="">
    </div>
</template>

<script>
import FormElementMixin from "../mixins/FormElementMixin";

export default {
    mixins: [
        FormElementMixin
    ],
    props: {
    },
    data() {
        return {
        }
    },
    computed: {

    },
    methods: {

    }
}
</script>

<style lang="scss" scoped>

</style>